






















































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class';
import {
  FormRowWings,
  SelectWings,
  FieldTooltip
} from 'wings-ui-components';
import TemplateInputWings from '@/components/Inputs/TemplateInputWings.vue';
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import { MsgTransports } from '@/store/types';
import {
  AcapiUploadedFile,
  PushImageType,
  PushImagesDetails,
  PushPlatformKey,
  PushTemplateItemImpl,
  pushImages,
} from '@/store/templates/types';
import {cloneDeep} from "lodash";
import {notifyError} from '@/utils/notify-helper';
import AndroidPushPreview from '@/components/Push/AndriodPushPreview.vue';
import IosPushPreview from '@/components/Push/IosPushPreview.vue';
import WindowsPushPreview from '@/components/Push/WindowsPushPreview.vue';
import MacOsPushPreview from '@/components/Push/MacOsPushPreview.vue';
import FileButton from '@/components/Inputs/FileButton.vue'
import CascadingOptions from '@/components/Others/CascadingOptions.vue';
import {
  ensurePushImage,
  findPushImage,
  getUploadFileId,
} from '@/utils/push-image-preview-url';

type PushImageFileId = string | number;
type PushImageSlot = {
  platform: PushPlatformKey;
  details: PushImagesDetails;
  type: PushImageType;
};
type PushImagesSnapshot = {
  details: PushImagesDetails;
  pushImages?: pushImages[];
};

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {
    FieldTooltip,
    TemplateInputWings,
    GenericTemplate,
    FormRowWings,
    SelectWings,
    AndroidPushPreview,
    IosPushPreview,
    WindowsPushPreview,
    MacOsPushPreview,
    FileButton,
    CascadingOptions
  }})
export default class PushTemplate extends Vue {
  @Ref('genericTemplate') genericTemplate: any;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  @Getter("pushApplications") applicationsList: any;
  @Getter("deliveryType") deliveryTypeList: any;
  @Getter("pushGroupApplications") groupApplicationsList: any;

  @Action("getPushApplications") actionGetApplications: any;
  @Action("getPushGroupApplications") actionGetGroupsApplications: any;
  @Action("uploadFiles") actionUploadFiles: any;
  @Action("deleteFile") actionDeleteFile: any;
  @Action("getFile") actionGetFile: any;

  private transport: MsgTransports = MsgTransports.PUSH;
  private templateObject: PushTemplateItemImpl = new PushTemplateItemImpl();
  activeApplication: string = 'application';
  applicationsValue = '';
  appGroups: {id: number; name: string}[] = [];
  applications: {id: number; name: string}[] = [];


  previewPhoneList = ['Android', 'iOS', 'MacOS', 'Windows']
  previewPhoneSelected = 'Android'

  buttonActions = [
    "link",
    "accept",
    "call",
    "hide",
    "copy",
    "custom",
  ]
  icon_set_in = null
  icon_zoom_in = null
  previewKey = 0
  private savedPushImages: Record<string, pushImages | undefined> = {};
  private isSavingTemplate = false;
  private lastSaveSucceeded = false;

  created() {
    this.setTemplate();
    try {
      this.actionGetApplications();
      this.actionGetGroupsApplications();
    } catch(error) {
      notifyError(error);
    }
  }

  prepareForSubmit() {
    this.clearSdkOnlyPushSettings();
    this.composeBadgeRuleForSave();
    this.prepareTemplateForSubmit();
  }

  mounted() {
    if (this.genericTemplate && typeof this.genericTemplate.onSaveItem === 'function') {
      const originalOnSaveItem = this.genericTemplate.onSaveItem.bind(this.genericTemplate);
      this.genericTemplate.onSaveItem = async (...args: any[]) => {
        const snapshot = this.snapshotPushImages();
        const obsoleteSavedFileIds = this.obsoleteSavedPushFileIds();
        this.isSavingTemplate = true;
        try {
          this.prepareForSubmit();
          await originalOnSaveItem(...args);
          this.lastSaveSucceeded = true;
          await this.deletePushFiles(obsoleteSavedFileIds);
          this.rememberSavedPushImages(this.genericTemplate.template);
        } catch (error) {
          this.restorePushImages(snapshot);
          this.ensurePushPlatformDetails();
          this.previewKey = Date.now();
        } finally {
          this.isSavingTemplate = false;
        }
      };
    }
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  async onLoadTemplate(template: any) {
    this.normalizePushImagesFromApi(template.androidPushDetails, 'android');
    this.normalizePushImagesFromApi(template.iosPushDetails, 'ios');
    this.normalizePushImagesFromApi(template.webPushDetails, 'web');
    await this.enrichPushImagesWithInternalUrls(template);
    this.parseBadgeRuleFromApi(template);
    this.clearSdkOnlyPushSettings();
    this.rememberSavedPushImages(template);
    this.lastSaveSucceeded = false;
    if (!template.applications?.length) this.activeApplication = 'appGroups';
    this.applications = template.applications || [];
    this.genericTemplate.template.applicationsIds = this.applications.map(app => app.id);
    this.appGroups = template.appGroups || [];
    this.genericTemplate.template.appGroupsIds = this.appGroups.map(app => app.id);
    this.$emit('onLoadTemplate', template)
  }

  onAddApplication(id: number) {
    if (this.genericTemplate.template.applicationsIds?.includes(id) || id == null) return;
    const option = this.applicationsList.find((item: any) => item.applicationId == id);
    if (!option) return;
    this.applications.push({id: option.applicationId, name: option.appName});
    this.genericTemplate.template.applicationsIds?.push(id);
  }

  onDeleteApplication(application: any) {
    const idx = this.applications.findIndex((item: any) => item.id == application.id);
    if (idx !== -1) {
      this.applications.splice(idx, 1);
      this.genericTemplate.template.applicationsIds?.splice(idx, 1);
    }
  }

  onAddAppGroup(id: number) {
    if (this.genericTemplate.template.appGroupsIds?.includes(id) || id == null) return;
    const option = this.groupApplicationsList.find((item: any) => item.id == id);
    if (!option) return;
    this.appGroups.push(option);
    this.genericTemplate.template.appGroupsIds?.push(id);
  }

  onDeleteAppGroup(appGroup: any) {
    const idx = this.appGroups.findIndex((item: any) => item.id == appGroup.id);
    if (idx !== -1) {
      this.appGroups.splice(idx, 1);
      this.genericTemplate.template.appGroupsIds?.splice(idx, 1);
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    const wrappedNext = async (value?: unknown) => {
      if (value === false) {
        next(false);
        return;
      }
      if (!this.isSavingTemplate && !this.lastSaveSucceeded) {
        await this.cleanupUnsavedPushFiles();
      }
      next(value);
    };
    this.genericTemplate.beforeLeave(to, from, wrappedNext)
  }

  @Watch('activeApplication', { immediate: false })
  onChangeActiveApplication(newVal: string) {
    this.applicationsValue = '';
    if (newVal === 'application') {
      this.appGroups = [];
      this.genericTemplate.template.appGroups = [];
      this.genericTemplate.template.appGroupsIds = [];
      this.genericTemplate.template.groupSelectionRule = undefined;
      this.genericTemplate.template.appSelectionRule = undefined;
    } else {
      this.applications = [];
      this.genericTemplate.template.applications = [];
      this.genericTemplate.template.applicationsIds = [];
      this.genericTemplate.template.appByDate = undefined;
      this.genericTemplate.template.appSelectionRule = this.genericTemplate.template.appSelectionRule || 1;
    }
  }

  @Watch('applications', { immediate: false })
  onChangeApplications(newVal: string) {
    if(newVal.length >= 2) {
      this.genericTemplate.template.appByDate = this.genericTemplate.template.appByDate || 1;
    } else {
      this.genericTemplate.template.appByDate = undefined;
    }
  }

  @Watch('appGroups', { immediate: false })
  onChangeAppGroups(newVal: string) {
    if(newVal.length >= 2) {
      this.genericTemplate.template.groupSelectionRule = this.genericTemplate.template.groupSelectionRule || 1;
    } else {
      this.genericTemplate.template.groupSelectionRule = undefined;
    }
  }

  @Watch('template.responsibleForView')
  onResponsibleForViewChange() {
    this.clearSdkOnlyPushSettings();
    this.previewKey = Date.now();
  }

  // async onTemplateChangePartner(partner:PartnerItem) {
  //   const appId: number = this.genericTemplate?.template.applicationId;
  //   this.genericTemplate.template.applicationId = null;
  //   if (partner){
  //     await this.actionGetApplications({partner:partner.name});
  //     if (this.applicationsList.some((app: PushApplicationItem) => app.id === appId))
  //       this.genericTemplate.template.applicationId = appId;
  //   }
  // }

  parseBadgeRuleFromApi(template: any) {
    const rule: string = template.badgeRule || 'do_not_change';
    const setToPrefix = 'set_to_';
    const increaseByPrefix = 'increase_by_';
    if (rule.startsWith(setToPrefix)) {
      this.icon_set_in = rule.substring(setToPrefix.length) as any;
      template.badgeRule = 'set_to';
    } else if (rule.startsWith(increaseByPrefix)) {
      this.icon_zoom_in = rule.substring(increaseByPrefix.length) as any;
      template.badgeRule = 'increase_by';
    }
  }

  composeBadgeRuleForSave() {
    const t: any = this.genericTemplate.template;
    const rule: string = t.badgeRule || '';
    if (rule.startsWith('set_to')) {
      const num = this.icon_set_in;
      t.badgeRule = num != null && num !== '' ? `set_to_${num}` : 'set_to';
    } else if (rule.startsWith('increase_by')) {
      const num = this.icon_zoom_in;
      t.badgeRule = num != null && num !== '' ? `increase_by_${num}` : 'increase_by';
    }
  }

  isSdkPushView(templateItem: { responsibleForView?: string }): boolean {
    return templateItem.responsibleForView === 'sdk';
  }

  removePushImageByType(details: PushImagesDetails | undefined, type: PushImageType) {
    if (!details?.pushImages?.length) {
      return;
    }
    details.pushImages = details.pushImages.filter((img) => img.type !== type);
    if (!details.pushImages.length) {
      delete details.pushImages;
    }
  }

  clearSdkOnlyPushSettings() {
    const template = this.genericTemplate.template;
    if (this.isSdkPushView(template)) {
      return;
    }
    template.badgeRule = 'do_not_change';
    this.icon_set_in = null;
    this.icon_zoom_in = null;
    this.removePushImageByType(template.androidPushDetails, 'banner');
    this.removePushImageByType(template.androidPushDetails, 'logo');
    this.removePushImageByType(template.iosPushDetails, 'banner');
  }

  addPushButton() {
    this.genericTemplate.template.pushButtons.push({
      id: '',
      text: '',
      appointment: '',
      appointmentValue: '',
    })
  }

  deletePushButton(idx: number) {
    this.genericTemplate.template.pushButtons.splice(idx, 1)
  }

  addAdditionParams() {
    this.genericTemplate.template.pushAdditionalParameters.push({
      name: '',
      value: '',
    })
  }

  deleteAdditionParams(idx: number) {
    this.genericTemplate.template.pushAdditionalParameters.splice(idx, 1)
  }

  pushImageExternalUrl(details: PushImagesDetails | undefined, type: PushImageType): string {
    return findPushImage(details, type)?.externalUrl || '';
  }

  pushImageSlotKey(platform: PushPlatformKey, type: PushImageType): string {
    return `${platform}:${type}`;
  }

  savedPushImageFileId(platform: PushPlatformKey, type: PushImageType): PushImageFileId | undefined {
    return getUploadFileId(this.savedPushImages[this.pushImageSlotKey(platform, type)]);
  }

  pushImageSlots(template: any = this.genericTemplate.template): PushImageSlot[] {
    return [
      { platform: 'android', details: template.androidPushDetails, type: 'banner' },
      { platform: 'android', details: template.androidPushDetails, type: 'logo' },
      { platform: 'ios', details: template.iosPushDetails, type: 'banner' },
      { platform: 'web', details: template.webPushDetails, type: 'banner' },
      { platform: 'web', details: template.webPushDetails, type: 'logo' },
    ];
  }

  pushImageDetailsList(template: any = this.genericTemplate.template): PushImagesDetails[] {
    return [
      template.androidPushDetails,
      template.iosPushDetails,
      template.webPushDetails,
    ];
  }

  rememberSavedPushImages(template: any) {
    this.savedPushImages = {};
    this.pushImageSlots(template).forEach(({ platform, details, type }) => {
      const image = findPushImage(details, type);
      this.savedPushImages[this.pushImageSlotKey(platform, type)] = image ? { ...image } : undefined;
    });
  }

  snapshotPushImages(): PushImagesSnapshot[] {
    return this.pushImageDetailsList().map((details) => ({
      details,
      pushImages: details.pushImages?.map((image) => ({ ...image })),
    }));
  }

  restorePushImages(snapshot: PushImagesSnapshot[]) {
    snapshot.forEach(({ details, pushImages }) => {
      details.pushImages = pushImages?.map((image) => ({ ...image }));
    });
  }

  async enrichPushImagesWithInternalUrls(template: any) {
    const detailsList: (PushImagesDetails | undefined)[] = [
      template.androidPushDetails,
      template.iosPushDetails,
      template.webPushDetails,
    ];
    const tasks: Promise<void>[] = [];
    for (const details of detailsList) {
      for (const image of details?.pushImages || []) {
        if (image.uploadFilesId && !image.internalUrl) {
          tasks.push(
            this.actionGetFile(image.uploadFilesId)
              .then((resp: any) => { image.internalUrl = resp?.data?.internal_url; })
              .catch(() => { /* silent: превью останется пустым по строгой логике */ })
          );
        }
      }
    }
    await Promise.all(tasks);
  }

  normalizePushImagesFromApi(details: PushImagesDetails | undefined, platform: PushPlatformKey) {
    if (!details?.pushImages?.length || details.pushImages.some((img) => img.type)) {
      return;
    }
    if (platform === 'ios') {
      details.pushImages[0].type = 'banner';
      details.pushImages = details.pushImages.slice(0, 1);
      return;
    }
    if (details.pushImages[0]) {
      details.pushImages[0].type = 'banner';
    }
    if (details.pushImages[1]) {
      details.pushImages[1].type = 'logo';
    }
    details.pushImages = details.pushImages.slice(0, 2);
  }

  prepareTemplateForSubmit() {
    this.pushImageDetailsList().forEach((details) => {
      const pushImages = (details.pushImages || [])
        .filter((img) => img.type && !!img.externalUrl?.trim())
        .map((img) => {
          const item: pushImages = {
            type: img.type,
            externalUrl: img.externalUrl!.trim(),
          };
          const uploadFileId = getUploadFileId(img);
          if (uploadFileId) {
            item.uploadFilesId = uploadFileId;
          }
          return item;
        });
      if (pushImages.length) {
        details.pushImages = pushImages;
      } else {
        delete details.pushImages;
      }
    });
    this.cleanupEmptyPushPlatformDetails();
  }

  cleanupEmptyPushPlatformDetails() {
    const template = this.genericTemplate.template;
    if (this.isEmptyAndroidPushDetails(template.androidPushDetails)) {
      delete template.androidPushDetails;
    }
    if (this.isEmptyIosPushDetails(template.iosPushDetails)) {
      delete template.iosPushDetails;
    }
  }

  ensurePushPlatformDetails() {
    const template = this.genericTemplate.template;
    if (!template.androidPushDetails) {
      template.androidPushDetails = { groupName: '', pushImages: [] };
    }
    if (!template.iosPushDetails) {
      template.iosPushDetails = { subtitle: '', pushImages: [] };
    }
  }

  isEmptyAndroidPushDetails(details?: PushImagesDetails & { groupName?: string }): boolean {
    if (!details) {
      return true;
    }
    return !details.groupName?.trim() && !(details.pushImages?.length);
  }

  isEmptyIosPushDetails(details?: PushImagesDetails & { subtitle?: string }): boolean {
    if (!details) {
      return true;
    }
    return !details.subtitle?.trim() && !(details.pushImages?.length);
  }

  obsoleteSavedPushFileIds(): Array<PushImageFileId | undefined> {
    const currentFileIds = new Set(
      this.pushImageSlots()
        .map(({ details, type }) => getUploadFileId(findPushImage(details, type)))
        .filter((id): id is PushImageFileId => id !== undefined && id !== null),
    );
    return Object.values(this.savedPushImages)
      .map((image) => getUploadFileId(image))
      .filter((id) => id !== undefined && id !== null && !currentFileIds.has(id));
  }

  unsavedPushFileIds(): Array<PushImageFileId | undefined> {
    return this.pushImageSlots()
      .map(({ platform, details, type }) => {
        const currentFileId = getUploadFileId(findPushImage(details, type));
        return currentFileId !== this.savedPushImageFileId(platform, type) ? currentFileId : undefined;
      });
  }

  async deletePushFiles(fileIds: Array<PushImageFileId | undefined>) {
    const uniqueFileIds = Array.from(new Set(fileIds.filter((id): id is PushImageFileId => id !== undefined && id !== null)));
    for (const fileId of uniqueFileIds) {
      try {
        await this.actionDeleteFile(fileId);
      } catch (error) {
        notifyError(error);
      }
    }
  }

  async cleanupUnsavedPushFiles() {
    await this.deletePushFiles(this.unsavedPushFileIds());
  }

  inputValue(value: string | Event): string {
    if (typeof value === 'string') {
      return value.trim();
    }
    return ((value.target as HTMLInputElement)?.value || '').trim();
  }

  async setPushImageExternalUrl(details: PushImagesDetails, type: PushImageType, value: string | Event) {
    const externalUrl = this.inputValue(value);
    if (externalUrl === this.pushImageExternalUrl(details, type)) {
      return;
    }

    this.lastSaveSucceeded = false;
    const image = findPushImage(details, type);
    const uploadFileId = getUploadFileId(image);

    if (!externalUrl) {
      if (details.pushImages) {
        details.pushImages = details.pushImages.filter((img) => img.type !== type);
      }
    } else {
      const pushImage = ensurePushImage(details, type);
      pushImage.externalUrl = externalUrl;
      delete pushImage.internalUrl;
      delete pushImage.uploadFilesId;
    }

    await this.deleteTemporaryPushFile(details, type, uploadFileId);
    this.previewKey = Date.now();
  }

  async deleteTemporaryPushFile(details: PushImagesDetails, type: PushImageType, fileId?: PushImageFileId) {
    const slot = this.pushImageSlots().find((item) => item.details === details && item.type === type);
    if (!slot || !fileId || fileId === this.savedPushImageFileId(slot.platform, type)) {
      return;
    }
    await this.deletePushFiles([fileId]);
  }

  async onPushImageFileChanged(details: PushImagesDetails, type: PushImageType, platform: PushPlatformKey, event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }

    const oldFileId = getUploadFileId(findPushImage(details, type));
    const formData = new FormData();
    formData.append('file', file);
    input.value = '';

    try {
      const resp = await this.actionUploadFiles(formData);
      const fileData = resp.data as AcapiUploadedFile;
      this.lastSaveSucceeded = false;
      if (oldFileId && oldFileId !== this.savedPushImageFileId(platform, type)) {
        await this.deletePushFiles([oldFileId]);
      }
      const pushImage = ensurePushImage(details, type);
      this.$set(pushImage, 'externalUrl', fileData.external_url);
      this.$set(pushImage, 'internalUrl', fileData.internal_url);
      this.$set(pushImage, 'uploadFilesId', fileData.id);
      this.previewKey = Date.now();
    } catch (error) {
      notifyError(error);
    }
  }
}
